import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import BeforeAfter from "@/components/site/BeforeAfter";
import Reviews from "@/components/site/Reviews";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyMobileCTA from "@/components/site/StickyMobileCTA";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#101010] text-white">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <BeforeAfter />
        <Reviews />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
